import { cx } from '@emotion/css';
import { useNavigationPreviousPage } from '@/hooks/useNavigationPreviousPage';
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import styles from './OrgProfileHeader.styles';

interface OrgProfileHeaderProps {
  image: string;
  trackButtonClick: (label: string) => void;
  toggleDrawer: (open: boolean) => (event: any) => void;
}

const OrgProfileHeader: React.FC<OrgProfileHeaderProps> = ({
  image,
  trackButtonClick,
  toggleDrawer,
}) => {
  const navigatePreviousPage = useNavigationPreviousPage();

  const goToPreviousPage = () => {
    trackButtonClick('Back button');
    navigatePreviousPage();
  };

  const handleClickShare = () => {
    trackButtonClick('Share Organization');
  };

  return (
    <div className={styles.container}>
      <img src={image} alt="Last org's flyer" className={styles.image} />
      <div className={styles.buttons}>
        <IconButton
          className={styles.button}
          onClick={goToPreviousPage}
          aria-label="Back button"
        >
          <CloseOutlinedIcon />
        </IconButton>
        <div>
          <IconButton
            className={cx(styles.button, styles.buttonSpacing)}
            aria-label="Share Org Informations"
            onClick={handleClickShare}
          >
            <IosShareOutlinedIcon />
          </IconButton>
          <IconButton
            className={styles.button}
            aria-label="More options"
            onClick={toggleDrawer(true)}
          >
            <MoreHorizOutlinedIcon />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default OrgProfileHeader;
